import { LoadState } from "../../constants/enums";
import { IFileUpload } from "../../features/FileUpload/components/FileUpload.type";

export interface IOperationalUpdatesState {
  list: IOperationalUpdate[];
  loading: LoadState;
}

export interface IOperationalUpdate {
  incremental_number: number | null;
  name: string;
  message: string;
  attachments: IFileUpload[];
  status: string;
}

export const initialOperationalUpdatesState: IOperationalUpdatesState = {
  list: [],
  loading: LoadState.NotLoaded,
};


export const initialOperationalUpdate: IOperationalUpdate = {
  incremental_number: null,
  name: "",
  message: "",
  attachments: [],
  status: "ACTIVE",
};  